import { TreeCard } from "../TreeCard";
import { PageContentWrapper, Row, Column, Group, Window } from "./style";

export const TreeWizard = ({
  putElementOnCenter,
  windowref,
  layers,
  targetPosition,
  wrapperref,
}) => (
  <Window ref={windowref}>
    <PageContentWrapper
      ref={wrapperref}
      style={{ top: -targetPosition[0], left: -targetPosition[1] }}
    >
      <Row>
        {layers.map((layer, layerKey) => (
          <Column key={`c${layerKey}`}>
            {layer.map((group, groupKey) => (
              <Group
                key={`g${groupKey}`}
                id={`g${group[0].position.slice(
                  0,
                  group[0].position.length - 1
                )}`}
              >
                {group.map(({ position, ...node }) => {
                  return (
                    <TreeCard
                      {...{
                        title: node.title,
                        content: node.body,
                        key: position,
                        onClick: () => {
                          const owner = `g${group[0].position.slice(
                            0,
                            group[0].position.length - 1
                          )}`;
                          putElementOnCenter(
                            { position, owner, ...node },
                            false
                          );
                        },
                      }}
                    />
                  );
                })}
              </Group>
            ))}
          </Column>
        ))}
      </Row>
    </PageContentWrapper>
  </Window>
);
